import React from "react";
import { RouteProps } from "react-router-dom";
import { AssessmentContent } from "../organisms/AssessmentScreens";
import { ErrorBoundary } from "../organisms/ErrorBoundary";

export const AssessmentTemplate: React.FC<RouteProps> = () => {
    return (
        <ErrorBoundary>
            <AssessmentContent />
        </ErrorBoundary>
    );
};
